export default {
    account: 'Account',
    'export': 'Export',
    'export-from-latest-matching': 'Export from latest matching',
    'export-as-excel': 'Export as excel file',
    'print-account-statement': 'Print account statement',
    'brief': '(Brief)',
    'view-match-table': 'Show reconciliation table',
    back: 'Back',

    'account-num-or-name': 'Account ID or name',
    'search-within-caption': 'Find via description',

    'from-date': 'Start date',
    'to-date': 'End date',
    'to': 'to',
    'show-all-columns': 'Show all columns',
    
    refresh: 'Refresh',
    'go-to-the-journal-of-entry': 'Go to journal entry',
    match: 'Conciliation',
    'account-match': 'Cancel account reconciliation',
    'account-unmatch': 'Account reconciliation',

    'are-you-sure-you-want-to-account-unmatch': 'Do you want to cancel the account reconciliation?',
    'are-you-sure-you-want-to-account-match': 'Do you want to reconcile the account?',
    
    'currency-balances': 'Currency balances:',
    'more-details': 'More details',
    
    'sum-debit': 'Total debit',
    'sum-credits': 'Total credit',
    'currency-debits': 'Foreign currencies debit',
    'currency-credits': 'Foreign currencies credit',
    'currency-equivalent': 'Balance in another currency',
    
    'select-the-currency-to-display-the-equivalent-value': 'Choose the currency to exchange',

    today: 'Today',
    balance: 'Balance:',

    'sum-result-headers': {
        'sum-debits': 'Total debit',
        'sum-credits': 'Total credit',
        balance: 'Balance',
        'equivalent-currency': 'Equivalent currency',
        'currency-equivalent': 'Currency equivalent',
        'currencies-balance': 'Currency balance',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'Foreign currencies debit',
        'currency-credits': 'Foreign currencies credit',
    },

    headers: {
        balance: 'Balance',
        debit: 'Debit',
        credit: 'Credit',
        note: 'Description',
        'currency-debit': 'Foreign currency debit',
        'currency-credit': 'Foreign currency credit',
        currency: 'Currency',
        'currency-price': 'Price',
        'currency-balances': 'Currency balance',
        'paper-document-no': 'Ref. Doc.',
        date: 'Date',
    },
}